import './Footer.sass';

const Footer = () => {
    return(
        <footer>
            <p className='copyright'>&copy;</p>
            <p>Samuel Thomas</p>
        </footer>
    )
}

export default Footer;